import OurLetShift from "@/components/backoffice/all-staff/shift-schedule/our-let-shift";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import RoadmapTabs from "@/components/backoffice/all-staff/time-sheet/roadmaps-tabs";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import CalendarTabs from "@/components/backoffice/all-staff/time-sheet/calenderTabs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "@/hooks/useAuth";
import { fetchCalender } from "@/redux/slice/staff-management/time-sheet-slice";
import hasPermission from "@/hooks/hasPermission";

function TimeSheet() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [monthDate, setMonthDate] = useState("");

  const hasCalender = hasPermission("back_office.staff_management.calender");
  const hasRoadmap = hasPermission("back_office.staff_management.roadmap");

  const defaultTab = hasCalender ? "calender" : (hasRoadmap ? "roadmap" : "");

  const effectiveMonthDate =
    monthDate ||
    (() => {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}`;
    })();

  useEffect(() => {
    if (!user?.restaurant_id) return;

    let isCancelled = false;

    const fetchData = async () => {
      try {
        const [calenderRes] = await Promise.all([
          dispatch(
            fetchCalender({
              restaurant_id: user.restaurant_id,
              query: effectiveMonthDate,
            })
          ).unwrap(),
        ]);
      } catch (err) {
        console.error("Error fetching time sheet data:", err);
      }
    };

    fetchData();

    return () => {
      isCancelled = true;
    };
  }, [user?.restaurant_id, effectiveMonthDate, dispatch]);

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "Time Sheet" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        {
          name: "Staff Management",
          path: "/backoffice/staff-management/staff/all",
        },
        {
          name: "Time Sheet",
          path: "/backoffice/staff-management/time-sheet",
        },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-between items-start md:items-center md:flex-row flex-col gap-5  w-full">
          <div className="flex gap-5 text-white ">
          </div>
        </div>
        <Tabs
          valueKey="staff-manage-time-sheet"
          className="bg-transparent relative"
          defaultValue={defaultTab}
        >
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            {hasCalender && (
              <TabsTrigger className="bg-transparent" value="calender">
                Calender
              </TabsTrigger>
            )}
            {hasRoadmap && (
              <TabsTrigger value="roadmap">Roadmap</TabsTrigger>
            )}
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          {hasCalender && (
            <CalendarTabs
              monthDate={effectiveMonthDate}
              setMonthDate={setMonthDate}
            />
          )}
          {hasRoadmap && <RoadmapTabs />}
        </Tabs>
      </div>
    </Layout2>
  );
}

export default TimeSheet;
